import React, { useEffect, useState, useRef } from 'react'
import { createUseStyles, useTheme } from 'react-jss'
import Inputmask from "inputmask"

import View from './View'

const useStyles = createUseStyles(theme => ({
  root: {
    display: 'flex',
    width: '100%',
    padding: '0 10px',
    flexDirection: 'column',
    boxSizing: 'border-box',
    //marginBottom: '32px',
    '@media(max-width: 700px)': {
      width: '100% !important',
      padding: '0 !important'
    }
  },
  label: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: '28px',
    color: '#454545',

    '@media(max-height: 976px)': {
      fontSize: '20px',
    },
  },
  description: {
    marginLeft: '10px',
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: '20px',
    color: '#82878C',

    '@media(max-height: 976px)': {
      fontSize: '16px',
    },
  },
  input: {
    appearance: 'none',
    '-webkit-appearance': 'none',

    height: '76px',
    width: '100%',

    marginTop: '8px',

    border: '1px solid #E5E5E5',
    boxSizing: 'border-box',
    borderRadius: '8px',

    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: '28px',
    letterSpacing: '0.02em',

    color: '#454545',
    padding: '0 16px',

    '@media(max-height: 976px)': {
      height: '54px',
      fontSize: '20px',
    },
    
    '&:focus': {
      outline: 0,
      borderColor: theme.colors.primary
    }
  },
  container: {
    position: 'relative'
  },
  icon: {
    display: 'flex',
    position: 'absolute',
    right: 0,
    fontSize: '28px',
    padding: '0 16px',
    marginTop: '20px',
    alignItems: 'center',
    color: '#454545',
  },
  inputFocus: {
   color: theme.colors.primary 
  },
  withError: {
    borderColor: '#DD3416',
    '&:focus': {
      borderColor: '#DD3416',
    }
  },
  feedback: {
    minHeight: '32px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '300',
    fontSize: '24px',    
    color: '#DD3416',

    '@media(max-height: 976px)': {
      fontSize: '18px',
    },
  }
}))


function InputField (props) {

  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
  const [ focus, setFocus ] = useState()
  const inputRef = useRef(null)

  useEffect(() => {
    if (inputRef && inputRef.current) {
      if (props.type === 'phone') {
        Inputmask("(99) 99999-9999").mask(inputRef.current)
      }
    }
  }, [ inputRef, props.type ])

  const onChange = e => {
    if (props.onChange) {
      props.onChange(e)
    }
  }

  const onKeyUp = e => {
    const key = e.charCode || e.keyCode;
    if (key !== 13 && props.onKeyUp ) {
      props.onKeyUp(e)
    }
  }

  const onKeyPress = e => {
    const key = e.charCode || e.keyCode
    if (key === 13 && props.onEnterKeyPress ) {
      props.onEnterKeyPress()
    }
  }

  const iconStyles = focus ? `${styles.icon} ${styles.inputFocus}` : styles.icon
  const inputStyles = props.error ? `${styles.input} ${styles.withError}` : styles.input

  return (
    <div className={styles.root} style={props.customStyles}>
      <div>
        <span className={styles.label} style={props.labelStyles}>
          {props.label}
        </span>
        <span className={styles.description} style={props.descriptionStyles}>
          {props.description}
        </span>
      </div>
      <div className={styles.container}>
        <div className={iconStyles}>
          { props.icon}
        </div>

        <input 
          ref={inputRef}
          className={inputStyles}
          type={props.type}
          inputMode={props.keyboardType}
          name={props.name}
          defaultValue={props.value || undefined} 
          placeholder={props.placeholder}
          required={props.required}
          onChange={onChange}
          onKeyUp={onKeyUp}
          onKeyPress={onKeyPress}

          autoCapitalize='words'
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
        />

        { !props.hideFeedback && 
          <View className={styles.feedback} style={props.errorStyles}>
            { props.error }
          </View>
        }
      </div>
    </div>
  )
}

export default InputField